<template>
    <div class="container offset">
         <div class="custom-form">

            <p>Veja aqui todas as solicitações recebidas. Você pode aceitar ou recusá-las.</p>
            <input 
                type="name"
                class="form-control input-personal"
                placeholder="Digite o nome do usuário..."
                v-model="searchByName"
                id="inlineFormCustomName"
                autocomplete="off"
            />

            <hr class="separator">

            <transition-group tag="div" v-if='filterSolicitacoes' class="listagem-solicitacao" name="listanimate">
                <div v-for="info in filterSolicitacoes" :key="info.idUsuario.idUsuario">
                    <div class="institution-row-style">
                        <div class="infos-text">
                            <i class="img-style ml-1 mr-2 fas fa-user"></i>
                            <label class="text-style"> {{ info.idUsuario.nome }} </label>
                        </div>
                        <div v-if="info.aceito == null">
                            <Button 
                                @click="setStatusInstiRequest(info.idNotificacao, 'false')"
                                section="descartar"
                                value="Recusar"
                                :isOutline="true"
                                :hasIcon="false"
                                class="button-style"
                            />  
                            <Button 
                                @click="setStatusInstiRequest(info.idNotificacao, 'true')"
                                section="salvar"
                                value="Aceitar"
                                :isOutline="true"
                                :hasIcon="false"
                                class="button-style ml-2"
                            />  
                        </div>
                        <div v-else-if="info.aceito == false">
                            <span class="recusado-text">RECUSADO</span>
                        </div>
                        <div v-else-if="info.aceito == true">
                            <span class="aceito-text">ACEITO</span>
                        </div>
                    </div> 
                </div>
            </transition-group>

            <transition-group v-else>
                <p>Sem resultados.</p>
            </transition-group> 
        
        </div>   
    </div>
</template>

<script>

import Button from '../../components/Button'
import { Notyf } from "notyf";
const notyf = new Notyf({
  duration: 5000,
  position: {
    x: 'left',
    y: 'bottom',
  }
})

export default {
    name: "SearchInstitution",
    data() {
        return {
            searchByName: '',
            infosData: [
                // {
                //     id: 1,
                //     name: 'Anglo RJ'
                // },
                // {
                //     id: 2,
                //     name: 'Anglo VV'
                // },
                // {
                //     id: 3,
                //     name: 'LEPES RP'
                // }
            ]
        }
    },
    components: {
        Button
    },
    async created() {
        
    },
    computed: {
        filterSolicitacoes: function() {
        //SE ESTIVER VAZIO O CAMPO DE BUSCA RETORNA TODOS
            var allRequests = 'this.$store.getters.getListInstiRequests';
            
            var query = allRequests
            query = query?.sort((a, b) => a?.idUsuario?.nome?.localeCompare(b?.idUsuario?.nome));
            

            if (this.searchByName.trim() == '') {
                query = allRequests
            }
            //SENAO ELE FILTRA PELO O QUE FOR DIGITADO
            else {
                query = allRequests?.filter(team => team.idUsuario.nome.trim().toLowerCase().match(this.searchByName.trim().toLowerCase()))
            }

            return query;
        }
    },
    methods: {
        async setStatusInstiRequest() {
            notyf.open({
                type: 'success',
                message: 'Solicitação atualizada!'
            });
        }
    },
    
}

</script>

<style scoped>

    .container{
        padding: 2%;
        width: 100%;
        background-color: white;
    }

    .title-style{
        font-size: 1.5rem;
        font-weight: 600;
        color: #656565;        
    }

    .image-style{
        display: block;
        margin-left: auto;
        margin-right: auto;
        width: 50%;
        padding: 1rem;
    }

    .button-div{
        text-align: right;
    }

    .recusado-text {
        color: #d40707;
        font-weight: bold;
    }

    .aceito-text {
        color: #038b25b4;
        font-weight: bold;
    }

    .institution-row-style{
        border-bottom: 1px solid #ddd;
        margin: 0;    
        padding: 0.5rem 0rem;
        text-align: left;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .img-style{
        font-size: 1.3rem;
        color: #0d9f9f;
        border-radius: 5rem;
    }

    .text-style{
        padding-top: 0.8rem;
        font-weight: 500;
    }

    .separator {
        border: none;
        height: 1px;
        margin: 1 0 0 0;
        margin-bottom: 0;
        background-color: rgba(51, 51, 51, 0.178);
    }

    .button-style {
        height: 2.2rem;
        margin-top: 0.35rem;
    }

    .input-personal {
        padding: 0.2rem 0.4rem;
        font-size: 0.938rem;
        font-weight: 400;
    }

    .select-personal, .input-personal {
        border-radius: 8px;
        background: #FCFCFC;
        outline: none;
        border: 1px solid rgba(0, 0, 0, 0.11);
        font-weight: lighter;
        padding: 0.2rem 0.4rem;
        box-shadow: 1px 2px 6px -3px rgb(0 0 0 / 25%);
    }

    .listagem-solicitacao {
        max-height: 300px;
    }

</style>
